export default __webpack_public_path__ + "static/media/cloud3.9328a85b.png";